import React from "react";
import banner1 from "../images/banners/BANNER1.jpg";
import banner2 from "../images/banners/BANNER2.jpg";
import banner3 from "../images/banners/BANNER3.jpg";
import banner4 from "../images/banners/BANNER4.jpg";
import "../styles/carousel.css";

export default function Carousel() {
  return (
    <>
      <div id="myCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#myCarousel"
            data-bs-slide-to="0"
            className="active indicator"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="1" aria-label="Slide 2" className="indicator"></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="2" aria-label="Slide 3" className="indicator"></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="3" aria-label="Slide 4" className="indicator"></button>
        </div>
        <div className="carousel-inner" role="listbox">
          <div className="carousel-item c-item active">
            <img src={banner1} className="d-block w-100 c-img" alt="..." loading="lazy" />
          </div>
          <div className="carousel-item c-item">
            <img src={banner2} className="d-block w-100 c-img" alt="..." loading="lazy" />
          </div>
          <div className="carousel-item c-item">
            <img src={banner3} className="d-block w-100 c-img" alt="..." loading="lazy" />
          </div>
          <div className="carousel-item c-item">
            <img src={banner4} className="d-block w-100 c-img" alt="..." loading="lazy" />
          </div>
        </div>
        <button className="carousel-control-prev buttons arrowButtons" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
          {/* <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span> */}
          {/* <span className="visually-hidden">Previous</span> */}
        </button>
        <button className="carousel-control-next buttons arrowButtons" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
          {/* <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span> */}
          {/* <span className="visually-hidden">Next</span> */}
        </button>
      </div>
    </>
  );
}
